import { TFileWithMeta } from '@components/FileUpload/components/dropzone/types/TFileWithMeta';
import { PrismaRepositoryAttachmentDto } from 'app/API';

export const mapAttachmentsToIFileWithMeta = (attachments: PrismaRepositoryAttachmentDto[]): TFileWithMeta[] => {
  const now = new Date().toISOString();
  return attachments.map((attachment) => ({
    meta: {
      Id: attachment.id,
      id: attachment.id,
      name: attachment.fileName,
      size: Number(attachment.fileSize),
      status: 'done',
      type: '',
      uploadedDate: now,
      percent: 100,
      lastModifiedDate: now,
    },
    file: new File([], attachment.fileName),
    cancel: () => {},
    upload: () => {},
  }));
};
